/*
  Animated <details> — WAAPI height, .5s cubic-bezier(.3, 1, .3, 1).

  Plain <details class="js-accordion">, enhanced by one delegated listener. Not
  `is="accordion-details"`: Safari never shipped customized built-in elements, so
  that pattern silently does nothing on iOS.

  - data-accordion-locked="true"  summary clicks are ignored (footer menus on desktop)
  - inside .accordion-parent      opening one closes its open siblings
  - .is-closing                   set for the length of a collapse, so CSS can flip
                                  icons/rules the moment it starts ([open]:not(.is-closing))
*/
(() => {
  if (window.__formeAccordion) return;
  window.__formeAccordion = true;

  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const EASE = 'cubic-bezier(.3, 1, .3, 1)';

  const settle = (d, open) => {
    d.open = open;
    d.classList.remove('is-closing');
    d.style.overflow = '';
    d._anim = null;
  };

  const animate = (d, open) => {
    // Measure before cancelling so a reversal starts from where it visually is.
    const from = d.getBoundingClientRect().height;
    if (d._anim) d._anim.cancel();
    if (reduced.matches || !d.animate) return settle(d, open);

    const summary = d.querySelector(':scope > summary');
    let to;
    if (open) {
      d.classList.remove('is-closing');
      d.open = true;
      to = d.getBoundingClientRect().height;
    } else {
      d.classList.add('is-closing');
      to = summary.getBoundingClientRect().height + (d.offsetHeight - d.clientHeight);
    }
    d.style.overflow = 'hidden';
    d._anim = d.animate({ height: [from + 'px', to + 'px'] }, { duration: 500, easing: EASE });
    d._anim.onfinish = () => settle(d, open);
  };

  document.addEventListener('click', (e) => {
    const summary = e.target.closest('summary');
    const d = summary && summary.parentElement;
    if (!d || !d.matches('details.js-accordion')) return;
    e.preventDefault();
    if (d.dataset.accordionLocked === 'true') return;

    const opening = !d.open || d.classList.contains('is-closing');
    if (opening) {
      const group = d.closest('.accordion-parent');
      if (group) {
        group.querySelectorAll('details.js-accordion[open]').forEach((other) => {
          if (other !== d && !other.classList.contains('is-closing')) animate(other, false);
        });
      }
    }
    animate(d, opening);
  });
})();
